import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import paths from '@paths';
import utils from '@utils';
import constants from '@constants';
import api from '@api';

export const signInEmail = async (
  value: any,
  formikAction: FormikHelpers<any>,
  setIsResetPasswordModal: any,
  setCognitoUser: any
) => {
  try {
    formikAction.setSubmitting(true);
    const cognitoUser = await utils.amplify.signIn(value.email, value.password);
    if (cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
      setCognitoUser(cognitoUser);
      setIsResetPasswordModal(true);
    } else {
      window.location.href = paths.dashboard.main;
    }
  } catch (err) {
    switch (err.code) {
      case 'UserNotFoundException': {
        notify(constants.ERRORS.INCORRECT_AUTHENTICATION, 'error');
        break;
      }
      case 'NotAuthorizedException': {
        notify(constants.ERRORS.INCORRECT_AUTHENTICATION, 'error');
        break;
      }
      case 'UserNotConfirmedException': {
        notify('認証コードを入力して、新規登録を完了してください', 'error');
        break;
      }
      default: {
        notify(constants.ERRORS.UNKNWON, 'error');
        break;
      }
    }
  } finally {
    formikAction.setSubmitting(false);
  }
};

export const resetInitialPassword = async (
  value: any,
  formikHelpers: FormikHelpers<any>,
  setIsResetPasswordModal: any,
  cognitoUser: any
) => {
  try {
    await utils.amplify.completeNewPassword(cognitoUser, value.password);

    const b: UserActivateBody = {sub: cognitoUser.username};
    await api.users.activate(b);

    notify(
      '初期パスワードの変更に成功しました。ダッシュボードに移動します。',
      'success'
    );
    setIsResetPasswordModal(false);
    setTimeout(() => {
      window.location.href = paths.dashboard.main;
    }, 2000);
  } catch (error) {
    notify('初期パスワードの変更に失敗しました');
  } finally {
    formikHelpers.setSubmitting(false);
  }
};
